import { createCollectionActions } from 'utils/actionsGenerator';

import { HIDE_CAMPAIGN, types } from './reducer';

const params = {
    embeds: [
        'applications',
        'boost',
        'company',
        'flags',
        'listing',
        'page',
        'product.media',
    ].join(','),
    'sort[createdAt]': 'desc',
};

export const { fetch } = createCollectionActions({
    name: 'campaigns',
    params,
    types,
    url: '/campaigns',
});

export const { fetch: fetchAdmin } = createCollectionActions({
    name: 'campaigns',
    params,
    types,
    url: '/campaigns-filter',
});

export const hideCampaign = (data) => ({
    payload: { campaignId: data.get('id') },
    type: HIDE_CAMPAIGN,
});
